import React from 'react';
import styles from './TopBar/topBar.module.scss';

export const AppName = () => (
  <div className={styles.appName}>
    <span className={styles.appName__title}>SUD Foncier éco</span>
  </div>
);

export default AppName;
